import React, {Component} from 'react';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';

/**
 * Mockup screen S8's "Monthly access review" (docs/mockups/access-control-mockups.html; slice
 * 4b-2 §3.8).
 *
 * A REPORT, NEVER AN AUTOMATIC REVOKE — the mockup's own caption, rendered on the panel because it
 * is the design constraint and not a footnote: nothing here writes anything.
 *
 * A finding with `count: null` renders **—**, not 0, with the reason on hover. Three of the seven
 * are unmeasurable today, and reporting zero for them would be a false clean bill of health on a
 * screen an auditor reads.
 */
class ReviewPanel extends Component {
  render() {
    const findings = this.props.findings || [];
    const measurable = findings.filter((f) => f.count !== null);
    const flagged = measurable.filter((f) => f.count > 0).length;

    return (
      <div className="rounded-card review-panel" data-testid="ac-review-panel">
        <h3>
          Monthly access review
          <span className="panel-count" data-testid="ac-review-count">
            {` ${flagged} of ${measurable.length} measurable findings need attention`}
          </span>
        </h3>

        <Table size="small" className="data-table">
          <TableHead>
            <TableRow>
              <TableCell><strong>Finding</strong></TableCell>
              <TableCell align="right"><strong>Count</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {findings.map((f) => (
              <TableRow
                key={f.key} hover
                className={f.count > 0 ? 'review-flagged' : ''}
                data-testid={f.count === null ? 'ac-review-unmeasurable' : 'ac-review-row'}
              >
                <TableCell>
                  {f.label}
                  {f.note && (
                    <Tooltip title={f.note}>
                      <span className="review-note-mark" data-testid="ac-review-note"> ⓘ</span>
                    </Tooltip>
                  )}
                </TableCell>
                <TableCell align="right">
                  {/* Not 0. A dash says "not measured"; a zero says "measured, and clean". */}
                  {f.count === null ? <span className="review-dash">—</span> : f.count}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <div className="review-caption" data-testid="ac-review-caption">
          A report, never an automatic revoke. Someone decides.
        </div>
      </div>
    );
  }
}

export default ReviewPanel;
